import { Image, FileVideo } from "lucide-react";
// import { useNotificationDispatch } from "amazon-chime-sdk-component-library-react";
// import { Storage } from "aws-amplify";

import { useCallback, useEffect, useState } from "react";

import { useDropzone, DropEvent, FileRejection } from "react-dropzone";
import { useForm } from "react-hook-form";
import { useRouter } from "next/navigation";
import { useToast } from "@/components/ui/use-toast";
import { v4 } from "uuid";
import NextImage from "next/image";

import { zodResolver } from "@hookform/resolvers/zod";
import * as z from "zod";

//import { getUser } from "@/lib/api/authentication";
// import useGenerateThumbnailFromVideo from "../../hooks/useGenerateThumbnail";
// import { logTrace } from "../../lib/sentryLogger";
import { languages, langCodes } from "@/models/languages";
import { getMedia } from "@/services/media";
// import RouteLoadingScreen from "../protected_routes/route-loading-screen";
// import * as Logger from "../../lib/sentryLogger";

import { Input } from "@/components/ui/input";

import { Textarea } from "@/components/ui/textarea";

import {
	Form,
	FormControl,
	FormField,
	FormItem,
	FormLabel,
	FormMessage,
} from "@/components/ui/form";

import {
	Tooltip,
	TooltipContent,
	TooltipProvider,
	TooltipTrigger,
} from "@/components/ui/tooltip";
import useGenerateThumbnailFromVideo from "@/hooks/useGenerateThumbnail";
import CircularProgressIndicator from "@/components/circular-progress-indicator";

let Storage: any;

function RouteLoadingScreen() {
	return (
		<>
			<div>
				<h1>Loading Screnn</h1>
			</div>
		</>
	);
}
// function getMedia(...args: any) {
// 	return args[0]
// }

type VideoFormSubmit = {
	id: string;
	user: string;
	title: string;
	description?: string;
	location: string;
	tags: [string];
	language: string;
};

export const UploadVideo = (props: any) => {
	const [titlecharCount, setTitleCharCount] = useState(0);
	const [charCount, setCharCount] = useState(0);

	// const [errors, setErrors] = useState({
	// 	description: "",
	// });

	// const notificationDispatch = useNotificationDispatch();
	const [isLoading, setIsLoading] = useState(false);
	const [videoTitle, setVideoTitle] = useState("");
	const [videoKey, setVideoKey] = useState("");
	const [isThumbnailSet, setIsThumbnailSet] = useState(false);
	const [videoThumbnail, setVideoThumbnail] = useState("");
	const [thumbnailKey, setThumbnailKey] = useState("");
	const [thumbnailFile, setThumbnailFile] = useState();
	const [ready, setReady] = useState(false);
	const [profileId, setProfileId] = useState("");
	const [featured, setFeatured] = useState(false);
	const [videoDescription, setVideoDescription] = useState("");
	const [videoLanguage, setVideoLanguage] = useState("");
	const [videoType, setVideoType] = useState("Skill");
	const [tags, setTags] = useState<string[]>([]);
	const [isBothTypes, setIsBothTypes] = useState(false);
	const [videoId, setVideoId] = useState("");
	const [fileProcessingFn, processedFile, isProcessing] =
		useGenerateThumbnailFromVideo();
	const router = useRouter();
	const [video, setVideo] = useState<File>();
	const [videoDuration, setVideoDuration] = useState<number | null>(null);
	const { toast } = useToast();
	const isPastLimit = videoDuration && videoDuration > 180;
	let type = "";

	const removeExt = (name: string) => {
		if (name === undefined) return;
		return name.substring(0, name.lastIndexOf(".")) || name;
	};
	useEffect(() => {
		if (!props.editMode) {
			setProfileId(props.userId);

			setVideoLanguage(langCodes[getLanguage().toLowerCase()]);
			form.resetField("language", { defaultValue: videoLanguage });
			if (props?.tier === "Promoter") {
				setFeatured(true);
			}
			return;
		}
		fetch(`/api/video?videoId=${props.videoId}`)
			.then((res) => res.json())
			.then((result) => {
				setVideoId(result.id);
				setProfileId(result.user);
				//TODO Null Assertion need check
				setVideoTitle(removeExt(result.title)!);
				setVideoType(result.type);
				if (result.type === "Both") setIsBothTypes(true);
				setVideoDescription(result.description);
				setVideoKey(result.location);
				if (result.thumbnail != "" && result.thumbnail != null) {
					setThumbnailFile(result.thumbnail);
					setVideoThumbnail(getMedia(result.thumbnail));
					setIsThumbnailSet(true);
					setThumbnailKey(result.thumbnail);
				}
				setTags(result.tags);
				setVideoLanguage(result.language);
				setFeatured(result.featured);
				setCharCount(result.description.length);

				form.reset({
					title: result.title,
					description: result.description,
					language: result.language,
				});
			});
	}, []);

	useEffect(() => {
		if (!!processedFile?.thumbFile && !isProcessing) {
			uploadThumbnail(processedFile?.thumbFile);
		}
	}, [processedFile, isProcessing]);

	const getLanguage = () =>
		navigator.language ||
		(navigator.languages &&
			navigator.languages.length &&
			navigator.languages[0]) ||
		"en";

	const uploadVideo = async () => {
		console.log("Vid", video);
		if (!video?.name) {
			setIsLoading(false);
			return;
		}

		if (isPastLimit) {
			setIsLoading(false);
			toast({
				title: "Videos must be no more than 3 minutes long",
				variant: "destructive",
				duration: 3000,
			});
			return;
		}

		try {
			const vidName =
				videoId + "." + video.name.split(".").pop()?.toLowerCase(); //force lowercase .mp4
			const res = await fetch(
				`/api/user/video/url?id=${profileId}&videoNm=${video!.name}`
			);
			const result = await res.json();
			if (!result?.videoId) {
				throw new Error(
					"Failed to generate presigned URL. Unable to proceed with update"
				);
			}
			setVideoId(result.videoId);

			// await axios.put(result?.url, video);
			await fetch(result?.url, {
				method: "PUT",
				body: video,
			});
			const newVideo = {
				id: result?.videoId,
				user: profileId,
				title: videoTitle,
				description: videoDescription,
				location: result?.key,
				thumbnail: thumbnailKey,
				tags: tags,
				type: type,
				language: videoLanguage,
				featured: featured,
			};

			//TO BE REVISITED

			// if (featured) {
			// 	await fetch("/api/video/featured", {
			// 		method: "PUT",
			// 		body: JSON.stringify({
			// 			videoUser: newVideo.user,
			// 			videoId: newVideo.id,
			// 			videoType: newVideo.type,
			// 		}),
			// 	});
			// 	// await updateFeaturedRecords(
			// 	// 	newVideo.user,
			// 	// 	newVideo.id,
			// 	// 	newVideo.type
			// 	// );
			// } else {
			// 	await fetch("/api/video/featured", {
			// 		method: "PUT",
			// 		body: JSON.stringify({
			// 			videoUser: newVideo.user,
			// 			videoId: "",
			// 			videoType: newVideo.type,
			// 		}),
			// 	});
			// 	// await updateFeaturedRecords(newVideo.user, "", newVideo.type);
			// }
			fetch("/api/video", {
				method: "POST",
				body: JSON.stringify({ newVideo }),
			}).then(() => router.push(`/watch/${newVideo.id}`));
		} catch (error) {
			setIsLoading(false);
			// toast.error("Upload Failed");
			toast({ title: "Upload Failed", variant: "destructive" });
			console.error("Upload failed", error);
		}
	};

	const getVideoDuration = (file: File) => {
		const video = document.createElement("video");
		video.preload = "metadata";
		video.onloadeddata = () => {
			setVideoDuration(video.duration);
		};
		video.src = URL.createObjectURL(file);
	};

	const onDrop = useCallback(
		(
			acceptedFiles: File[],
			fileRejections: FileRejection[],
			event: DropEvent
		) => {
			acceptedFiles.map(async (file) => {
				setVideo(file);

				// generateThumbnail(file, file.name.split(".")[0]);
				fileProcessingFn(file);
				//check if video duration is more than 3 minutes
				await getVideoDuration(file);
			});
		},
		[]
	);

	const {
		isDragActive,
		getRootProps,
		getInputProps,
		isDragReject,
		acceptedFiles,
		fileRejections,
	} = useDropzone({
		onDrop,
		multiple: false,
		accept: {
			"video/mp4": [".mp4"],
		},
		validator: extensionValidator,
	});

	const maxSize = 1048576;

	function extensionValidator(file: any) {
		let ext = file.name.split(".").pop()?.toLowerCase();
		if (ext != "mp4") {
			return {
				code: "file-rejected",
				message: "File type not accepted, sorry!",
			};
		}

		return null;
	}

	const isRejectedFile =
		fileRejections.length > 0 &&
		fileRejections[0].file.name.split(".").pop()?.toLowerCase() != "mp4";

	const onSubmit = async (e: any) => {
		setIsLoading(true);
		if (videoDescription.length < 50) {
			setIsLoading(false);
			// setErrors({ description: "Minimum of 50 characters required" });
			return;
		}
		// setErrors({ description: "" });

		type = videoType;

		if (props?.tier === "Promoter") {
			type = "Promotional";
		} else {
			if (isBothTypes) {
				type = "Both";
			} else {
				type = "Skill";
			}
		}

		const newVideo = {
			id: videoId,
			user: profileId,
			title: videoTitle,
			description: videoDescription,
			location: videoKey,
			thumbnail: thumbnailKey,
			tags: tags,
			type: type,
			language: videoLanguage,
			featured: featured,
		};

		console.log(newVideo);

		if (!props.editMode) {
			// new video
			await uploadVideo();
			return;
		}
		if (featured) {
			await fetch("/api/video/featured", {
				method: "PUT",
				body: JSON.stringify({
					videoUser: newVideo.user,
					videoId: newVideo.id,
					videoType: newVideo.type,
				}),
			});
		} else {
			await fetch("/api/video/featured", {
				method: "PUT",
				body: JSON.stringify({
					videoUser: newVideo.user,
					videoId: "",
					videoType: newVideo.type,
				}),
			});
		}
		await fetch("/api/video", {
			method: "POST",
			body: JSON.stringify({ newVideo }),
		});
		router.push(`/watch/${newVideo.id}`);
	};

	const cancelUpload = () => {
		props.setEdit(false);
		props.setUpload(false);
	};

	const uploadThumbnail = async (e: any) => {
		// thumbnailpic-${v4()}

		const thumbName =
			e.Key === "thumbnailpic"
				? e.name
				: `thumbnailpic-${v4()}` + "." + e.name.split(".").pop();

		//This would be converted to whatever route handlers is used these calls
		let file = e.Key === "thumbnailpic" ? e.Body : e;
		let key = `${profileId}/thumbnails/${thumbName}`;
		const res = await fetch(`/api/video/thumbnailUrl?location=${key}`);
		const response = await res.json();
		await fetch(response?.url!, {
			method: "PUT",
			body: file,
		});
		setThumbnailKey(`${profileId}/thumbnails/${thumbName}`);
		const url = await getMedia(`${profileId}/thumbnails/${thumbName}`);
		setVideoThumbnail(url);
		setIsThumbnailSet(true);
	};

	const addTag = (e: React.KeyboardEvent<HTMLInputElement>) => {
		e.preventDefault();
		// Destructuring
		const { value } = e.target as HTMLInputElement;
		if (e.key !== "Enter") return;

		if (value != "" && tags.length < 6) {
			setTags((old) => [...old, value]);
		}
		(e.target as HTMLInputElement).value = "";
	};

	const removeTag = (index: any) => {
		setTags(tags.filter((el: any, i: any) => i !== index));
	};

	const preventEnterSubmit = (e: React.KeyboardEvent<HTMLInputElement>) => {
		if (e.key == "Enter") e.preventDefault();
	};

	const changeVideoDescription = (e: any) => {
		setCharCount(e.target.value.length);
		setVideoDescription(e.target.value);
	};

	const changeVideoTitle = (e: any) => {
		setTitleCharCount(e.target.value.length);
		setVideoTitle(e.target.value);
	};

	const uploadFormSchema = z.object({
		title: z.string().max(65, {
			message: "Video title is too long.",
		}),

		description: z
			.string()
			.max(1000, {
				message: "Description is too long.",
			})
			.min(50, {
				message: "Description is too short",
			}),

		language: z.string(),
	});

	type UploadFormValues = z.infer<typeof uploadFormSchema>;

	const defaultValues: Partial<UploadFormValues> = {
		description: videoDescription,
		title: videoTitle,
		language: videoLanguage,
	};

	const form = useForm<UploadFormValues>({
		resolver: zodResolver(uploadFormSchema),
		defaultValues,
		mode: "onChange",
	});

	// return (<><h1>Real Upload Video Page</h1></>)
	return (
		<div className="content-wrapper upload-page edit-page ">
			<div className="w-full">
				{isLoading && (
					<div className="absolute bg-opacity-80 z-10 h-screen w-full flex items-center justify-center">
						<div className="flex items-center">
							<CircularProgressIndicator />
						</div>
					</div>
				)}
				<div className="flex flex-row">
					<div className="w-full">
						{!props.editMode && (
							<div className="pt-10 flex flex-wrap">
								<div className="w-full">
									<TooltipProvider>
										<Tooltip>
											<TooltipTrigger asChild>
												<div
													{...getRootProps({
														className:
															"flex justify-center bg-gray-200  w-full border-dashed border-4 border-gray-400 py-8",
													})}>
													<input {...getInputProps()} />

													{video?.name !== "" ? (
														<>
															<FileVideo className="w-10 h-8"></FileVideo>
															<div className="text-black font-bold">
																{video?.name}
															</div>
														</>
													) : (
														<>
															{!isDragActive && (
																<>
																	{isRejectedFile ? (
																		"File type not accepted, sorry!"
																	) : (
																		<>
																			Drag and drop file
																			here, or click to
																			select file
																			<br />
																			<em>
																				(Only mp4 files will
																				be accepted)
																			</em>
																		</>
																	)}
																</>
															)}
														</>
													)}
												</div>
											</TooltipTrigger>
											<TooltipContent>
												<p>
													Videos go through content moderation
													process that can take up to 24hrs to
													complete before it becomes available in
													our search engine.
												</p>
											</TooltipContent>
										</Tooltip>
									</TooltipProvider>
								</div>
							</div>
						)}
					</div>
				</div>
			</div>

			<div className="flex flex-col items-start w-full">
				<Form {...form}>
					<form onSubmit={form.handleSubmit(onSubmit)} className="w-full">
						<div className=" text-left font-sans text-lg font-semibold pt-6 pb-6 text-gray-800 sm:pt-4 sm:pb-4">
							Upload Details
						</div>
						<div className="flex flex-col items-start w-full">
							<div className="flex flex-col items-start  w-full">
								<label htmlFor="e1" className="mb-2">
									Video Thumbnail
								</label>
								<div className="flex flex-col items-start rounded-sm w-full flex-auto sm:h-50 sm:mb-4">
									<label
										htmlFor="thumb"
										style={{
											position: "relative",
										}}>
										{!isThumbnailSet ? (
											<Image
												style={{
													width: "100%",
													height: "150px",
												}}></Image>
										) : (
											<NextImage
												className="aspect-[1.59763313609/1]"
												src={videoThumbnail}
												alt="No Thumb"
												width={250}
												height={120}
											/>
										)}
										<TooltipProvider>
											<Tooltip>
												<TooltipTrigger asChild>
													<NextImage
														className="absolute w-8 h-8 rounded-full border-none bg-pink-600 p-1.5 opacity-75 bottom-0 right-0"
														src="/images/upload.png"
														alt=""
														width={8}
														height={8}
													/>
												</TooltipTrigger>
												<TooltipContent>
													<p>Add a video thumbnail (PNG, JPG)</p>
												</TooltipContent>
											</Tooltip>
										</TooltipProvider>
									</label>
									<input
										className="h-12"
										type="file"
										accept="image/*"
										hidden
										onChange={(e: any) => {
											uploadThumbnail(e?.target?.files[0]);
										}}
										id="thumb"
									/>
								</div>
							</div>

							{/* <div className="flex flex-col items-start w-full">
							<div className="form-group mb-7">
								<label htmlFor="e1">Video Thumbnail</label>
								<div className="flex flex-wrap">
									<div className="rounded-sm w-full h-28 sm:h-50 sm:mb-4">
										<label htmlFor="thumb" className="relative">
											{!isThumbnailSet ? (
												<Image
													style={{
														width: "100%",
														height: "110px",
													}}></Image>
											) : (
												<div className="w-full lg:w-1/1">
													<img
														className="aspect-square max-w-[180px] max-h-[180px]"
														src={videoThumbnail}
														alt="No Thumb"
													/>
												</div>
											)}

											<TooltipProvider>
												<Tooltip>
													<TooltipTrigger asChild>
														<img
															className="absolute w-8 h-8 rounded-full border-none bg-pink-600 p-1.5 opacity-75 bottom-0 left-4 "
															src="/images/upload.png"
															alt=""
														/>
													</TooltipTrigger>
													<TooltipContent>
														<p>
															Add a video thumbnail (PNG, JPG)
														</p>
													</TooltipContent>
												</Tooltip>
											</TooltipProvider>
										</label>
										<input
											className="h-12"
											type="file"
											accept="image/*"
											hidden
											onChange={(e: any) => {
												uploadThumbnail(e?.target?.files[0]);
											}}
											id="thumb"
										/>
									</div>
								</div>
							</div> */}

							<div className="flex flex-col items-start  w-full">
								<FormField
									control={form.control}
									name="title"
									render={({ field }) => (
										<FormItem className="w-full">
											<FormLabel className="text-base">
												Video Title
											</FormLabel>
											<FormControl>
												<Input
													required
													onKeyDown={preventEnterSubmit}
													onInput={changeVideoTitle}
													className="w-full rounded-sm bg-white border border-gray-300 px-4 py-3 h-11"
													{...field}
												/>
											</FormControl>
											<FormMessage />
										</FormItem>
									)}
								/>

								<div className=" feedback-count count self-end ">
									{titlecharCount} / 65
								</div>
							</div>

							<div className="flex flex-col items-start  w-full">
								<FormField
									control={form.control}
									name="description"
									render={({ field }) => (
										<FormItem className="w-full">
											<FormLabel className="text-base">
												About (Minimum of 50 characters)
											</FormLabel>
											<FormControl>
												<Textarea
													required
													onInput={changeVideoDescription}
													className="styledScrollbar w-full rounded-sm bg-white border border-gray-300 px-4 py-3 h-11"
													placeholder="What is this video about?"
													{...field}
												/>
											</FormControl>
											<FormMessage />
										</FormItem>
									)}
								/>

								<div className="self-end">{charCount} / 1000</div>
							</div>

							<div className="flex flex-col items-start w-full">
								<FormField
									control={form.control}
									name="language"
									render={({ field }) => (
										<FormItem className="w-full">
											<FormLabel className="text-base">
												Language in Video
											</FormLabel>
											<FormControl>
												<select
													required
													onChange={(e) =>
														setVideoLanguage(e.target.value)
													}
													className="w-full rounded-sm border border-gray-300 px-4 py-3 h-11"
													value={videoLanguage}>
													<option value="">-- select --</option>
													{languages.map((lang) => (
														<option key={lang} value={lang}>
															{lang}
														</option>
													))}
												</select>
											</FormControl>
											<FormMessage />
										</FormItem>
									)}
								/>
							</div>

							<div className="w-full flex flex-row gap-x-6 justify-start mt-5">
								<div className=" flex flew-row justify-start ">
									<label className="text-left">
										<label className="checkbox ">
											<input
												type="checkbox"
												onChange={() => setFeatured(!featured)}
												checked={featured}
												name="#"></input>
											<span className="arrow"></span>
										</label>{" "}
										<span>
											Featured Video <br />{" "}
											<small style={{ color: "#7e7e7e" }}>
												Show on Home page (only one video allowed)
											</small>
										</span>
									</label>
								</div>

								{(props?.tier === "Teacher" ||
									props?.tier === "TeacherPlus") && (
									<div className="w-full lg:w-1/2">
										<div className="checkbox-div ">
											<label>
												<label className="checkbox">
													<input
														type="checkbox"
														onChange={() =>
															setIsBothTypes(!isBothTypes)
														}
														checked={isBothTypes}
														name="#"></input>
													<span className="arrow"></span>
												</label>{" "}
												<span>
													Show in Products and Businesses searches
												</span>
											</label>
										</div>
									</div>
								)}
							</div>
						</div>
						<div className="flex flex-col items-start">
							<div className="w-full pt-5 lg:w-1/3 u-category">
								Category ( you can select upto 6 categories)
							</div>
							<div className="flex ">
								<div className="w-full ">
									{tags.map((tag, index: any) => (
										<div
											className="text-sm mr-2 mb-2 bg-pink-300 inline-block px-3 py-2 rounded-full"
											key={index}>
											<span className="text">{tag}</span>
											<span
												className="h-5 w-5 bg-red-600 text-white rounded-full inline-flex justify-center items-center ml-2 text-lg cursor-pointer"
												onClick={() => removeTag(index)}>
												&times;
											</span>
										</div>
									))}
								</div>
							</div>
							<small>press Enter to add</small>

							<input
								id="tags"
								type="text"
								className="w-full rounded-sm border border-gray-300 px-4 py-3 h-11"
								onKeyUp={addTag}
								onKeyDown={preventEnterSubmit}
							/>
						</div>
						<div className=" flex-col sm:flex-row items-center flex justify-center sm:space-x-6 ">
							{props.showCancel && (
								<button
									className="text-center  mt-16 bg-white text-rose-600 py-3.5 border-2 border-rose-600 rounded-full font-semibold w-full sm:w-1/4 hover:bg-rose-600 hover:text-white"
									onClick={cancelUpload}
									type="submit">
									Cancel
								</button>
							)}
							<button
								className="mt-16 text-center bg-rose-600 text-white mr-0 py-3.5 border-2 border-rose-600 rounded-full font-semibold  w-full sm:w-1/4 hover:bg-white hover:text-rose-600"
								type="submit">
								Save
							</button>
						</div>
					</form>
				</Form>

				<div className="py-12">
					<p>
						By submitting your videos to BazaarRoom, you acknowledge that
						you agree to BazaarRoom&#39;s{" "}
						<a
							className="modal text-rose-600 hover:underline"
							href="/legal">
							Terms of Service
						</a>{" "}
						and{" "}
						<a href="/policy" className="text-rose-600 hover:underline">
							Community Guidelines
						</a>
						.
					</p>
					<p className="hidden sm:block">
						Please be sure not to violate others&#39; copyright or privacy
						rights.
					</p>
					<p>
						Videos go through content moderation process that can take up
						to 24hrs to complete before it becomes available in our search
						engine.
					</p>
				</div>
			</div>
		</div>
	);
};
